module.exports = __webpack_public_path__ + "img/103.f88f9133.svg";